import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function M7Icon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="M7">
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M8.8 19.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.6c.2 0 .3 0 .5.1.1.1.2.2.3.4l1.5 3.8 1.6-3.8c.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1h.6c.2 0 .3.1.4.2.1.1.2.2.2.4V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-3.9l-1 2.3c-.1.2-.2.3-.3.4-.1.1-.3.1-.5.1h-.3c-.2 0-.3 0-.5-.1-.1-.1-.2-.2-.3-.4l-1-2.3V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.3zm8.5-5.9c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h4c.2 0 .3.1.4.2.1.1.2.2.2.4v.2c0 .4-.1.7-.3 1.1-.9 1.5-1.6 3.1-2.2 4.9-.1.2-.2.3-.3.4s-.3.1-.5.1h-.7c-.1 0-.2-.1-.3-.2s-.1-.2 0-.4c.7-1.9 1.6-3.7 2.6-5.3h-2.9z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
